import { z } from 'zod/v4';
import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { Brand } from '../branded-types';
import { EFooterBlockType } from './footer-block-type.enums';
import { ACCESSIBLE_IMAGE_SCHEMA, IAccessibleImage } from './image.interfaces';
import { ILink, LINK_SCHEMA } from './link.interfaces';

export type AddressAreaId = Brand<string, 'addressAreaId'>;

export const ADDRESS_AREA_SCHEMA: z.ZodType<IAddressArea> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as AddressAreaId)
    .optional(),
  isActive: z.boolean(),
  texts: z.array(NORMAL_TEXT_SCHEMA),
  accessibleImages: z.array(ACCESSIBLE_IMAGE_SCHEMA).optional(),
  links: z.array(LINK_SCHEMA).optional(),
  type: z.enum(EFooterBlockType).optional(),
});

export interface IAddressArea {
  id?: AddressAreaId;
  isActive: boolean;
  texts: INormalText[];
  accessibleImages?: IAccessibleImage[];
  links?: ILink[];
  type?: EFooterBlockType | string;
}
